import brandPortalOrdersbrandOrderToken from "@faire/web-api/routes/brand-portal/orders/brandOrderToken";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { isOrderReplaced } from "../../utils/orderInfo";
import { Bold } from "../common/Bold";
export var DamageMissingIA = function DamageMissingIA(_ref) {
  var context = _ref.context;
  var isReplacement = isOrderReplaced(context);
  if (isReplacement) {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "LZxyBC",
      defaultMessage: [{
        "type": 0,
        "value": "Quando um revendedor assinala um artigo como em falta ou danificado, recebe um e-mail e uma notificação na "
      }, {
        "children": [{
          "type": 0,
          "value": "página de informações da encomenda"
        }],
        "type": 8,
        "value": "OrderLinkFormatting"
      }, {
        "type": 0,
        "value": ". A informação sobre o problema comunicado indica quais foram os artigos (e as quantidades) assinalados como em falta ou danificados. No caso dos artigos assinalados como danificados, também serão apresentadas fotografias dos danos. Estes artigos são automaticamente removidos da fatura do revendedor."
      }],
      values: {
        OrderLinkFormatting: function OrderLinkFormatting(chunks) {
          var _context$brandOrder, _context$brandOrder$b;
          return _OrderLinkFormatting(chunks, (_context$brandOrder = context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : (_context$brandOrder$b = _context$brandOrder.brand_order) === null || _context$brandOrder$b === void 0 ? void 0 : _context$brandOrder$b.token);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "DpO7YM",
      defaultMessage: [{
        "type": 0,
        "value": "Se considerar que um revendedor assinalou incorretamente um artigo como em falta ou danificado, pode contestar a denúncia."
      }]
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "G5ytU0",
      defaultMessage: [{
        "type": 0,
        "value": "No caso das condições de pagamento no dia seguinte, pode contestar diretamente através da secção de "
      }, {
        "children": [{
          "type": 0,
          "value": "problemas comunicados"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " na "
      }, {
        "children": [{
          "type": 0,
          "value": "página de informações da encomenda"
        }],
        "type": 8,
        "value": "OrderLinkFormatting"
      }, {
        "type": 0,
        "value": ". Se tiverem sido usadas outras opções de pagamento, pode contactar a nossa equipa de apoio para obter mais assistência com qualquer disputa."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        },
        OrderLinkFormatting: function OrderLinkFormatting(chunks) {
          var _context$brandOrder2, _context$brandOrder2$;
          return _OrderLinkFormatting(chunks, (_context$brandOrder2 = context.brandOrder) === null || _context$brandOrder2 === void 0 ? void 0 : (_context$brandOrder2$ = _context$brandOrder2.brand_order) === null || _context$brandOrder2$ === void 0 ? void 0 : _context$brandOrder2$.token);
        }
      }
    })));
  } else {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "b3fCmJ",
      defaultMessage: [{
        "type": 0,
        "value": "Quando um revendedor assinala um artigo como em falta ou danificado, recebe um e-mail e uma notificação na "
      }, {
        "children": [{
          "type": 0,
          "value": "página de informações da encomenda"
        }],
        "type": 8,
        "value": "OrderLinkFormatting"
      }, {
        "type": 0,
        "value": ". A informação sobre o problema comunicado indica quais foram os artigos (e as quantidades) assinalados como em falta ou danificados. No caso dos artigos assinalados como danificados, também serão apresentadas fotografias dos danos. Estes artigos são automaticamente removidos da fatura original do revendedor e deduzidos do seu pagamento."
      }],
      values: {
        OrderLinkFormatting: function OrderLinkFormatting(chunks) {
          var _context$brandOrder3, _context$brandOrder3$;
          return _OrderLinkFormatting(chunks, (_context$brandOrder3 = context.brandOrder) === null || _context$brandOrder3 === void 0 ? void 0 : (_context$brandOrder3$ = _context$brandOrder3.brand_order) === null || _context$brandOrder3$ === void 0 ? void 0 : _context$brandOrder3$.token);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "+plhEc",
      defaultMessage: [{
        "type": 0,
        "value": "Se o revendedor solicitou a substituição destes artigos, encontrará uma nova encomenda criada automaticamente na página "
      }, {
        "children": [{
          "type": 0,
          "value": "Encomendas"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ". Depois de processar a nova encomenda de substituição, receberá um pagamento em separado."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "DpO7YM",
      defaultMessage: [{
        "type": 0,
        "value": "Se considerar que um revendedor assinalou incorretamente um artigo como em falta ou danificado, pode contestar a denúncia."
      }]
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "G5ytU0",
      defaultMessage: [{
        "type": 0,
        "value": "No caso das condições de pagamento no dia seguinte, pode contestar diretamente através da secção de "
      }, {
        "children": [{
          "type": 0,
          "value": "problemas comunicados"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " na "
      }, {
        "children": [{
          "type": 0,
          "value": "página de informações da encomenda"
        }],
        "type": 8,
        "value": "OrderLinkFormatting"
      }, {
        "type": 0,
        "value": ". Se tiverem sido usadas outras opções de pagamento, pode contactar a nossa equipa de apoio para obter mais assistência com qualquer disputa."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        },
        OrderLinkFormatting: function OrderLinkFormatting(chunks) {
          var _context$brandOrder4, _context$brandOrder4$;
          return _OrderLinkFormatting(chunks, (_context$brandOrder4 = context.brandOrder) === null || _context$brandOrder4 === void 0 ? void 0 : (_context$brandOrder4$ = _context$brandOrder4.brand_order) === null || _context$brandOrder4$ === void 0 ? void 0 : _context$brandOrder4$.token);
        }
      }
    })));
  }
};
var _OrderLinkFormatting = function _OrderLinkFormatting(chunks, brandOrderToken) {
  if (!brandOrderToken) {
    return /*#__PURE__*/React.createElement(Bold, null, chunks);
  } else {
    return /*#__PURE__*/React.createElement(Button, {
      variant: "tertiary",
      linkTo: brandPortalOrdersbrandOrderToken(brandOrderToken),
      target: "_blank"
    }, /*#__PURE__*/React.createElement(Bold, null, chunks));
  }
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};